import React from 'react';
import config from '../config';
import ComparePanel from './ComparePanel';
import BackButton from './BackButton';

function SavedComparisonsPage({ setPage, savedComparisons, setCompareList, setShowComparePanel, setSavedAiAnalysis, loadSavedComparisons }) {
  console.log('SavedComparisonsPage rendered, comparisons:', savedComparisons);
  const [localShowComparePanel, setLocalShowComparePanel] = React.useState(false);
  const [localSavedAiAnalysis, setLocalSavedAiAnalysis] = React.useState(null);
  const [localCompareList, setLocalCompareList] = React.useState([]);
  
  const handleViewComparison = async (comparison) => {
    console.log('Viewing comparison:', comparison);
    console.log('AI Analysis:', comparison.ai_analysis);
    
    try {
      const patentsToLoad = [];
      for (const pn of comparison.patent_numbers) {
        const response = await fetch(config.API_URL + "/api/search/patent-number/" + pn);
        const data = await response.json();
        if (data.results && data.results.length > 0) {
          const p = data.results[0];
          patentsToLoad.push({
            id: p.patent_number,
            title: p.title,
            summary: p.abstract,
            abstract: p.abstract,
            assignee: p.assignee,
            filing_date: p.filing_date,
            grant_date: p.grant_date,
            status: p.status || 'Live',
            ipc_codes: p.ipc_codes || [],
            cpc_codes: p.cpc_codes || []
          });
        }
      }
      setCompareList(patentsToLoad);
      setLocalCompareList(patentsToLoad);
      setLocalSavedAiAnalysis(comparison.ai_analysis || null);
      setLocalShowComparePanel(true);
    } catch (error) {
      alert('Error loading comparison: ' + error.message);
    }
  };

  const handleDeleteComparison = async (comparisonId) => {
    if (!window.confirm('Delete this comparison?')) return;
    const token = localStorage.getItem('token');
    try {
      await fetch(config.API_URL + "/api/saved-comparisons/" + comparisonId + "?token=" + token, {
        method: 'DELETE'
      });
      loadSavedComparisons();
    } catch (error) {
      alert('Error deleting: ' + error.message);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'white' }}>
      <header style={{ padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <BackButton onClick={() => setPage('search')} />
          <img
            src="/logo.svg"
            alt="PatTrak Logo"
            style={{ height: '32px', cursor: 'pointer' }}
            onClick={() => setPage('search')}
          />
        </div>
      </header>
      <main style={{ maxWidth: '800px', margin: '80px auto', padding: '0 16px' }}>
        <h1 style={{ fontSize: '36px', fontWeight: 'bold', color: '#1d2934', marginBottom: '16px' }}>
          Patent Comparisons
        </h1>

        {savedComparisons.length === 0 ? (
          <p style={{ fontSize: '16px', color: '#5e778a' }}>You haven't saved any comparisons yet.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {savedComparisons.map((comparison) => (
              <div key={comparison.id} style={{ border: '1px solid #5e778a', padding: '16px', borderRadius: '8px' }}>
                <h3 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '8px', color: '#1d2934' }}>
                  {comparison.name}
                </h3>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '12px' }}>
                  {comparison.patent_numbers.map((pn, i) => (
                    <span key={i} style={{
                      backgroundColor: '#f1f5f9',
                      padding: '4px 12px',
                      borderRadius: '4px',
                      fontSize: '14px',
                      color: '#334155'
                    }}>
                      {pn}
                    </span>
                  ))}
                </div>
                <p style={{ fontSize: '13px', color: '#64748b', marginBottom: '12px' }}>
                  Saved: {new Date(comparison.created_at).toLocaleDateString()}
                </p>
                <div style={{ display: 'flex', gap: '12px' }}>
                    <button
                      onClick={() => handleViewComparison(comparison)}
                      style={{
                        background: '#8b5cf6',
                        color: 'white',
                        border: 'none',
                        padding: '8px 16px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}
                    >
                      View Comparison
                    </button>
                    
                    {comparison.ai_analysis && (
                      <button
                        onClick={() => alert(comparison.ai_analysis)}
                        style={{
                          background: '#10b981',
                          color: 'white',
                          border: 'none',
                          padding: '8px 16px',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontSize: '14px',
                          fontWeight: '600'
                        }}
                      >
                        📄 View AI Analysis
                      </button>
                    )}
                    
                    <button
                      onClick={() => handleDeleteComparison(comparison.id)}
                    style={{
                      background: '#ef4444',
                      color: 'white',
                      border: 'none',
                      padding: '8px 16px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '600'
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
     
      <ComparePanel
        showComparePanel={localShowComparePanel}
        setShowComparePanel={setLocalShowComparePanel}
        compareList={localCompareList}
        savedAiAnalysis={localSavedAiAnalysis}
        setSavedAiAnalysis={setLocalSavedAiAnalysis}
      />
    </div>
  );
}

export default SavedComparisonsPage;
